/**
 * 文件链接转文件流下载--主要针对pdf 解决谷歌浏览器a标签下载pdf直接打开的问题
 * @param url  ：文件链接
 * @param fileName  ：文件名;
 * @param type  ：文件类型;
 * @param fn  ：进度回调方法;
 */
function saveFileToLink(url, fileName, type, fn) {
    // if (!CheckUrl(url)) {
    //   throw new Error("传入参数不合法,不是标准的文件链接");
    // } else {
      var xhr = new XMLHttpRequest();
      url = url.includes('https:') ? url.replace('https:', '') : url.replace('http:', ''); //资源路径动态获取请求的方式HTTPS或HTTP
      xhr.open('get', url, true);
      xhr.setRequestHeader('Content-Type', 'application/' + type);
      xhr.setRequestHeader("If-Modified-Since", "0"); //解决缓存问题,每次请求都去请求服务器获取最新数据
      xhr.responseType = "blob";
      xhr.onprogress = function (e) {
        //文件下载进度
        if (fn && typeof fn == 'function') {
          fn(e); //监听文件下载进度;
        }
      }, xhr.onload = function () {
        if (this.status == 200) {
          //接受二进制文件流
          var blob = this.response;
          saveFileToBlob(blob, fileName, type);
        }
      }, xhr.send();
    // }
  }

  function saveFileToBlob(blob, tagFileName) {
    // if (fileType) {
    //   windowconsole.warn('未传入文件类型,例如文件类 word(docx) excel(xlsx) ppt jpg png等');
    // }
    // if (isBlob(blob)) {
      var downloadElement = document.createElement('a');
      var href = window.URL.createObjectURL(blob); //创建下载的链接
      downloadElement.href = href;
      downloadElement.download = tagFileName; //下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象
    // } else {
    //  window.console.warn('不是blob对象类型的参数,可选择saveFileToBase64(Base64对象,文件类型)或saveFileToLink(文件链接,文件名,文件类型,进度回调方法)');
    // }
  }
  exports.saveFileToLink = saveFileToLink;